import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils/src/flow-with-safe-component/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import { getIsClassicSubtaskPanel } from '../../state/context/selectors.tsx';
import {
	getAllIssues,
	getInProgressIssues,
	getCompletedIssues,
} from '../../state/entities/selectors.tsx';
import type { State } from '../../state/types.tsx';
import { ProgressSummaryView } from './view.tsx';

export default flowWithSafeComponent(
	connect((state: State) => {
		const totalIssues = getAllIssues(state);
		const inProgressIssues = getInProgressIssues(state);
		const completedIssues = getCompletedIssues(state);

		return {
			isClassicSubtaskPanel: getIsClassicSubtaskPanel(state),
			totalIssueCount: totalIssues.length,
			inProgressIssueCount: inProgressIssues.length,
			completedIssueCount: completedIssues.length,
		};
	}, {}),
)(ProgressSummaryView);
